
<section class="ny-text-section">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="ny-confirmation">
          <img src="/assets/img/ny-true.png" alt="img" />
          <h1>Thank you, Your order has been placed!</h1>
          <p>Your order number is <u>TS-{{ ("00000"+orderId).slice(-8) }}</u>. A confirmation email has been sent.</p>
          <p><span>Please check your spam folder in case you haven’t received the email.</span></p>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="orderData">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table ny-details-table">
            <tr class="row1">
              <td>ORDER DETAILS</td>
              <td></td>
              <td>#{{ ("00000"+orderId).slice(-8) }}</td>
            </tr>
            <tr class="row2">
              <td>
                Delivery For: <span class="ny-br-block"></span>
                {{ orderData.billing.first_name }} <span class="ny-br-block"></span>
                <!-- {{ orderData.billing.first_name + ' ' + orderData.billing.last_name }} <span class="ny-br-block"></span> -->
                {{ orderData.billing.phone }} <span class="ny-br-block"></span>
                {{ orderData.billing.email }}

              </td>
              <td>
                Shipping Address: <span class="ny-br-block"></span>
               {{ orderData.shipping.address }} <span class="ny-br-block"></span>
                {{ orderData.shipping.city }} {{ orderData.shipping.country }} <span class="ny-br-block"></span>
              </td>
              <td>
                Billing Address: <span class="ny-br-block"></span>
                {{ orderData.billing.address }} <span class="ny-br-block"></span>
                {{ orderData.billing.city}} {{ orderData.billing.country }}<span class="ny-br-block"></span>
              </td>
            </tr>
            <!-- <tr>
              <td>
                Estimated Delivery Date
              </td>
              <td></td>
              <td>
                {{ orderData.delivery_date | date: 'longDate' }}
              </td>
            </tr> -->
          </table>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="list-ul text-center">
          <a  routerLink="/terms-conditions">
            Terms &amp; Conditions
          </a>
          <a routerLink="/privacy-policy">
            Privacy Policy
          </a>
          <!-- <a routerLink="/delivery-policy">
            Delivery Policy
          </a>
          <a routerLink="/return-policy">
            Return Policy
          </a> -->
        </div>
      </div>
    </div>
  </div>
</div>

